// HIDDEN during the browse-only relaunch: native trading is parked and cart
// checkout executed via Reservoir, so the navbar cart renders nothing.
// To restore, render the disabled cart button again here.
const CartButton = () => {
  return null
}

export default CartButton
